import { useTranslation } from 'react-i18next';

import { DataPanel, DataPanelGroup, DataPanelInlineItem, DataPanelRow, PanelInfoWithIcon } from '@/ui';
import { DateFormatter } from '@/features/shared/DateFormatter';

export type AppleEedExpiredSectionProps = {
  expiredAtUtc: string;
};

export function AppleEedExpiredSection({ expiredAtUtc }: AppleEedExpiredSectionProps) {
  const { t } = useTranslation();

  return (
    <DataPanel header="Apple EED data">
      <div className="bg-light p-2">
        <PanelInfoWithIcon icon="fal fa-clock-rotate-left" text={t('Incident_InfoPanel_AppleEed_Expired')} />
        <div className="text-center small text-black-50 mt-1">{t('Incident_InfoPanel_AppleEed_Expired_Description')}</div>
        <DataPanelGroup>
          <DataPanelRow>
            <DataPanelInlineItem title={t('Incident_InfoPanel_AppleEed_ExpiredAt')}>
              <DateFormatter date={expiredAtUtc} formatType="calendar" />
            </DataPanelInlineItem>
          </DataPanelRow>
        </DataPanelGroup>
      </div>
    </DataPanel>
  );
}
